import React from 'react'
import { AdminNodeContainer } from '../../'

const AdminConfiguration = (props) => {
  const {
    config,
    rootNode,
  } = props

  return (
    <AdminNodeContainer
      config={config}
      rootNode={rootNode}
    />
  )
}

export default AdminConfiguration



// WEBPACK FOOTER //
// ./src/modules/admin/components/adminConfiguration.jsx